<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="queryForm" layout="inline" :labelCol="{ style: { width: '90px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称" :help="null">
              <global-select
                v-decorator="['planName', { rules: [{ required: true }] }]"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ planType: 102, dataType: 1 }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-form :form="startForm" layout="inline" :labelCol="{ style: { width: '60px' } }">
          <div class="plan-time pt5 pb5">当前状态</div>
          <a-row class="pl20">
            <a-col :md="7" :sm="24" class="form-line1">
              <a-form-item label="最近一次运行时间" :labelCol="{ style: { width: '120px' } }">
                <a-input v-decorator="['lastRunTime']" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24" class="form-line2">
              <a-form-item label="阶段">
                <a-input v-decorator="['phaseName']" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24" class="form-line2" v-show="false">
              <a-form-item label="阶段">
                <a-input v-decorator="['phase']" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24" class="form-line2">
              <a-form-item label="状态">
                <a-input v-decorator="['curStatusName']" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24" class="form-line1">
              <a-form-item label="计划下次运行时间" :labelCol="{ style: { width: '120px' } }">
                <a-input v-decorator="['nextRunTime']" disabled />
              </a-form-item>
            </a-col>
          </a-row>
          <div class="plan-time pt5 pb5">运行计划</div>
          <a-row class="pl20">
            <a-col :md="10" :sm="24">
              <a-form-item label="运行方式">
                <a-radio-group v-decorator="['operationMode']" :disabled="!queryForm.getFieldsValue().planName">
                  <a-radio v-for="(item, index) in operationModeList" :key="index" :value="item.lookupCode">{{ item.lookupValue }}</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col v-if="startForm.getFieldsValue().operationMode === 'SPECIFY'" :md="8" :sm="24">
              <a-form-item label="运行时间" :labelCol="{ style: { width: '80px' } }">
                <a-date-picker
                  v-decorator="['operationTime', { rules: [{ required: true, message: '请选择运行时间' }] }]"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{ defaultValue: $moment('00:00:00', 'HH:mm:ss') }"
                />
              </a-form-item>
            </a-col>
            <a-col v-if="startForm.getFieldsValue().operationMode === 'REPEAT'" :md="7" :sm="24">
              <a-form-item label="运行间隔" :labelCol="{ style: { width: '80px' } }" class="interval-type">
                <a-input-group compact>
                  <a-input-number v-decorator="['runningInterval', { rules: [{ required: true, message: '请输入运行间隔' }] }]" :min="0" />
                  <global-select
                    v-decorator="['intervalType']"
                    selectType="select"
                    :selectData="intervalTypeList"
                    :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                    :allowClear="false"
                  />
                </a-input-group>
              </a-form-item>
            </a-col>
            <a-col v-if="startForm.getFieldsValue().operationMode === 'REPEAT'" :md="7" :sm="24">
              <a-form-item label="起始时间" :labelCol="{ style: { width: '80px' } }">
                <a-date-picker
                  v-decorator="['operationTime', { rules: [{ required: true, message: '请选择起始时间' }] }]"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{ defaultValue: $moment('00:00:00', 'HH:mm:ss') }"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <div class="btn-line pt5 pb10">
            <div class="plan-time">运行状态</div>
            <!-- <a-button class="btn1" :disabled="!queryForm.getFieldsValue().planName || !PHASE_TYPE2.includes(startForm.getFieldsValue().phase)" :loading="gameOverLoading" @click="gameOver()" v-hasPermi="['scp:scpMrpPlans:abortPlan']">强制终止</a-button> -->
            <a-button type="primary" class="btn2" :loading="readyGoLoading" @click="readyGo()" v-hasPermi="['scp:scpMrpPlans:startPlan']">启动</a-button>
            <!-- <a-button type="primary" :disabled="!queryForm.getFieldsValue().planName" class="btn2" @click="readyRun()">运行</a-button> -->
            <a-button type="primary" :disabled="!queryForm.getFieldsValue().planName || tableList.length === 0" class="btn2" @click="$refs.dailyRecordModal.show(queryForm.getFieldsValue())">查看运行日志</a-button>
            <a-button type="primary" class="btn2" @click="goDetail">计划请求列表</a-button>
          </div>
        </a-form>
        <!-- 表格 -->
        <a-table
          ref="table"
          :columns="columns"
          :loading="pageParams.tableLoading"
          :data-source="tableList"
          :pagination="false"
          row-key="id"
          :scroll="{ x: 1200 }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
            <div :key="item.dataIndex">
              <span v-if="item.type === 'link'">
                <a @click="$refs.createModal.show(record)">{{ text }}</a>
              </span>
              <span v-else-if="item.type === 'switch'">
                <a-switch :checked="record[item.dataIndex] === 'Y'" :disabled="record.necessaryFlag === 'Y' && record.enableFlag === 'Y'" @change="statusOnChange(record, item.dataIndex)" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </a-table>
        <!-- 底部分页按钮 -->
        <Page v-show="false" ref="page" :pageParams.sync="pageParams" @getList="getList" />
        <create-form ref="createModal" @handle-success="handleOk" />
        <daily-record-modal ref="dailyRecordModal" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import {
  apiScpMrpPlansAbortPlan,
  apiScpMrpPlansStartPlan,
  apiScpMrpPlanStagesUpdate,
  apiScpMasterControlMasterControl,
  apiScpMrpPlansSamePlannedTask
} from '@/api/scp/factoryCallMaterial/runCallMaterialPlan'
import CreateForm from './components/CreateForm'
import DailyRecordModal from '@/components/DailyRecordModal/index'

export default {
  name: 'RunCallMaterialPlan',
  components: {
    CreateForm,
    DailyRecordModal
  },
  data () {
    return {
      pageParams: {
        automatic: false,
        pageUrl: '/scp/scpMrpPlans/materialCallPlan',
        tableLoading: false
      },
      // 查询参数
      queryForm: this.$form.createForm(this, { name: 'queryForm' }),
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '序号',
          dataIndex: 'stageNumber',
          align: 'center'
        },
        {
          title: '阶段名称',
          dataIndex: 'stageCodeName',
          scopedSlots: { customRender: 'stageCodeName' },
          align: 'center',
          type: "link"
        },
        {
          title: '说明',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '启用',
          dataIndex: 'enableFlag',
          scopedSlots: { customRender: 'enableFlag' },
          align: 'center',
          type: "switch"
        },
        {
          title: '运行阶段',
          dataIndex: 'phaseName',
          align: 'center'
        },
        {
          title: '运行状态',
          dataIndex: 'statusName',
          align: 'center'
        },
        {
          title: '提交人',
          dataIndex: 'requestBy',
          align: 'center'
        },
        {
          title: '实际开始时间',
          dataIndex: 'actualStartDate',
          scopedSlots: { customRender: 'actualStartDate' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '实际完成时间',
          dataIndex: 'actualCompletionDate',
          scopedSlots: { customRender: 'actualCompletionDate' },
          width: 160,
          align: 'center',
          type: "text"
        }
      ],
      startForm: this.$form.createForm(this, { name: 'startForm' }),
      operationModeList: [], // 运行计划
      intervalTypeList: [], // 运行间隔
      PHASE_TYPE: ["TERMINATING", "RUNNING", "PENDING"], // 阶段-状态(启动按钮判断)
      PHASE_TYPE2: ["RUNNING", "PENDING"], // 阶段-状态(强制终止按钮判断)
      gameOverLoading: false,
      readyGoLoading: false
    }
  },
  created () {
    this.getLookupList('SYS_REQUEST_RUN_MODE', 'operationModeList')
    this.getLookupList('SYS_REQUEST_INTERVAL_TYPE', 'intervalTypeList')
  },
  mounted () {},
  methods: {
    // 计划请求列表
    goDetail () {
      this.$router.push({ name: `Call-material-plan-list`, query: { planType: "102", planName: this.queryForm.getFieldsValue().planName } })
    },
    // 运行按钮
    readyRun () {
      this.readyGoLoading = true
      apiScpMasterControlMasterControl({ planName: this.queryForm.getFieldsValue().planName, scheduleVersion: "" }).then((response) => {
        if (response.code === 200) {
          this.$message.success('运行成功!')
          this.handleQuery()
        } else {
          this.$message.error(response.msg)
        }
        this.readyGoLoading = false
      }).catch(e => {
        this.readyGoLoading = false
      })
    },
    // 强制终止
    gameOver () {
      const self = this
      this.$confirm({
        title: '此操作将终止该计划所有定时或运行中的请求，请确认是否需要终止？',
        content: `注：如果需要仅取消某个请求，请从【计划请求列表】中查询取消。`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          self.gameOverLoading = true
          apiScpMrpPlansAbortPlan({ planName: self.queryForm.getFieldsValue().planName }).then((response) => {
            if (response.code === 200) {
              self.$message.success('强制终止成功!')
              self.handleQuery()
            } else {
              self.$message.error(response.msg)
            }
            self.gameOverLoading = false
          }).catch(e => {
            self.gameOverLoading = false
          })
        },
        onCancel () {
          self.gameOverLoading = false
        }
      })
    },
    // 启动
    readyGo () {
      if (!this.startForm.getFieldsValue().operationMode) {
        this.$message.warning('请选择运行方式')
        return
      }
      const self = this
      this.startForm.validateFields((err, values) => {
        if (!err) {
          apiScpMrpPlansSamePlannedTask(self.queryForm.getFieldsValue().planName).then((response) => {
            if (response.code === 200) {
              if (response.data) {
                self.$confirm({
                  title: '启动提醒',
                  content: `该计划还有正在运行中的请求，请注意是否重复提交运行`,
                  okText: '确定',
                  cancelText: '取消',
                  icon: () => <a-icon type='exclamation-circle' />,
                  onOk () {
                    self.readyGoRequest()
                  }
                })
              } else {
                self.readyGoRequest()
              }
            }
          })
        }
      });
    },
    readyGoRequest () {
      const params = this.startForm.getFieldsValue()
      params.planName = this.queryForm.getFieldsValue().planName
      apiScpMrpPlansStartPlan(params).then((response) => {
        if (response.code === 200) {
          this.$message.success('启动成功!')
          this.handleQuery()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    /** 查询列表 */
    getList (data) {
      data.lastRunTime = data.lastRunTime && this.$moment(data.lastRunTime).format('YYYY-MM-DD HH:mm:ss')
      data.nextRunTime = data.nextRunTime && this.$moment(data.nextRunTime).format('YYYY-MM-DD HH:mm:ss')
      this.startForm.setFieldsValue(data)
      this.tableList = data.stagesList
    },
    // 新增/修改框事件
    handleOk () {
      this.handleQuery()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      if (!this.queryForm.getFieldsValue().planName) {
        this.$message.warning('计划名称不能为空')
        return;
      }
      const params = this.queryForm.getFieldsValue()
      params.dataType = 1
      this.$refs.page.getFirstPage(params)
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryForm.resetFields()
      this.startForm.resetFields()
      this.tableList = []
    },
    statusOnChange (record, dataIndex) {
      record[dataIndex] = record[dataIndex] === 'Y' ? 'N' : 'Y'
      apiScpMrpPlanStagesUpdate(record).then(response => {
        if (response.code === 200) {
          this.$message.success('修改成功')
          this.handleQuery()
        } else {
          this.$message.error(response.msg)
        }
      }).catch(e => {
        this.handleQuery()
      })
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    }
  }
}
</script>

<style scoped lang="less">
.plan-time{
  // font-size: 16px;
  font-weight: bold;
}
.pt5 {
  padding-top: 5px;
}
.pb5 {
  padding-bottom: 5px;
}
.pb10 {
  padding-bottom: 10px;
}
.pl20{
  padding-left: 20px;
}
.btn-line{
  display: flex;
  align-items: center;
  .btn1{
    margin-left: 50px;
  }
  .btn2{
    margin-left: 70px;
  }
}
.interval-type {
  /deep/.ant-select{
    width: 60px;
  }
}
.form-line1 {
  input {
    width: 160px;
  }
}
.form-line2 {
  input {
    width: 130px;
  }
}
</style>
